import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconLogoWiggotBlue from '../build/icon-logo-wiggot-blue'

export const IconLogoWiggotBlueComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconLogoWiggotBlue} />
}

export default IconLogoWiggotBlueComponent
